/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Filter_DatesInputs */



/**
* | output |
* | --- |
* | "Dates" |
*
* @param {Tournaments_Filter_DatesInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_filter_dates = /** @type {((inputs?: Tournaments_Filter_DatesInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Filter_DatesInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dates")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fechas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Datas")
	if (locale === "it") return /** @type {LocalizedString} */ ("Date")
	return /** @type {LocalizedString} */ ("Dates")
});